import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Reuses the same legal page styles
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .legal-root { font-family: 'DM Sans', sans-serif; color: #0f1117; background: #ffffff; overflow-x: hidden; }
  .legal-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 999; padding: 0 32px; height: 68px; display: flex; align-items: center; justify-content: space-between; background: rgba(255,255,255,0.92); backdrop-filter: blur(12px); border-bottom: 1px solid rgba(0,0,0,0.08); box-shadow: 0 2px 20px rgba(0,0,0,0.06); }
  .legal-nav-logo { font-family: 'Syne', sans-serif; font-size: 22px; font-weight: 800; color: #1a5c2a; text-decoration: none; display: flex; align-items: center; gap: 10px; letter-spacing: -0.3px; }
  .legal-logo-icon { width: 36px; height: 36px; background: #1a5c2a; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 18px; }
  .legal-nav-links { display: flex; align-items: center; gap: 8px; }
  .legal-btn-signin { font-size: 14px; font-weight: 600; color: #1a5c2a; text-decoration: none; padding: 9px 20px; border: 1.5px solid #1a5c2a; border-radius: 10px; transition: all 0.2s; }
  .legal-btn-signin:hover { background: #1a5c2a; color: white; }
  .legal-btn-start { font-size: 14px; font-weight: 600; color: white; text-decoration: none; padding: 9px 20px; background: #1a5c2a; border-radius: 10px; transition: all 0.2s; box-shadow: 0 2px 8px rgba(26,92,42,0.35); }
  .legal-btn-start:hover { background: #145022; }
  .legal-hero { background: linear-gradient(135deg, #0a1f0f 0%, #1a5c2a 50%, #0d3318 100%); padding: 120px 24px 64px; text-align: center; position: relative; overflow: hidden; }
  .legal-hero::after { content: ''; position: absolute; inset: 0; background-image: radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px); background-size: 32px 32px; pointer-events: none; }
  .legal-hero-tag { display: inline-flex; align-items: center; gap: 8px; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); color: rgba(255,255,255,0.9); font-size: 13px; font-weight: 500; padding: 6px 16px; border-radius: 50px; margin-bottom: 20px; position: relative; z-index: 1; }
  .legal-hero h1 { font-family: 'Syne', sans-serif; font-size: clamp(36px, 5vw, 60px); font-weight: 800; color: white; letter-spacing: -2px; margin-bottom: 16px; position: relative; z-index: 1; }
  .legal-hero-sub { font-size: 16px; color: rgba(255,255,255,0.65); position: relative; z-index: 1; }
  .legal-body { max-width: 820px; margin: 0 auto; padding: 64px 24px 80px; }
  .legal-toc { background: #f8faf8; border: 1px solid #e8f0e8; border-radius: 16px; padding: 28px 32px; margin-bottom: 48px; }
  .legal-toc-title { font-family: 'Syne', sans-serif; font-size: 16px; font-weight: 700; color: #0f1117; margin-bottom: 16px; }
  .legal-toc-list { list-style: none; display: grid; grid-template-columns: 1fr 1fr; gap: 8px 24px; }
  .legal-toc-list li a { font-size: 14px; color: #1a5c2a; text-decoration: none; font-weight: 500; transition: color 0.2s; }
  .legal-toc-list li a:hover { color: #145022; text-decoration: underline; }
  .legal-section { margin-bottom: 48px; scroll-margin-top: 88px; }
  .legal-section-title { font-family: 'Syne', sans-serif; font-size: 22px; font-weight: 800; color: #1a5c2a; margin-bottom: 16px; padding-bottom: 10px; border-bottom: 2px solid #e8f5e9; display: flex; align-items: center; gap: 10px; }
  .legal-section-title span { width: 32px; height: 32px; background: #1a5c2a; color: white; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 800; flex-shrink: 0; }
  .legal-subsection { margin-bottom: 20px; }
  .legal-subsection-title { font-family: 'Syne', sans-serif; font-size: 16px; font-weight: 700; color: #0f1117; margin-bottom: 8px; }
  .legal-p { font-size: 15px; line-height: 1.75; color: #333; margin-bottom: 12px; }
  .legal-list { list-style: none; margin: 8px 0 12px 0; }
  .legal-list li { font-size: 15px; line-height: 1.75; color: #333; padding: 6px 0 6px 24px; border-bottom: 1px solid #f0f0f0; position: relative; }
  .legal-list li:last-child { border-bottom: none; }
  .legal-list li::before { content: '✓'; position: absolute; left: 0; color: #1a5c2a; font-weight: 700; }
  .legal-highlight { background: #e8f5e9; border-left: 4px solid #1a5c2a; border-radius: 0 10px 10px 0; padding: 16px 20px; margin: 16px 0; }
  .legal-highlight p { font-size: 14px; color: #1a5c2a; font-weight: 500; line-height: 1.6; margin: 0; }
  .legal-warning { background: #fff8e1; border-left: 4px solid #f59e0b; border-radius: 0 10px 10px 0; padding: 16px 20px; margin: 16px 0; }
  .legal-warning p { font-size: 14px; color: #92400e; font-weight: 500; line-height: 1.6; margin: 0; }
  .legal-caps { font-size: 13px; line-height: 1.75; color: #555; background: #f8f8f8; border: 1px solid #e0e0e0; border-radius: 10px; padding: 16px 20px; margin-bottom: 12px; }
  .legal-contact-card { background: linear-gradient(135deg, #0a1f0f, #1a5c2a); border-radius: 16px; padding: 32px; text-align: center; margin-top: 56px; }
  .legal-contact-card h3 { font-family: 'Syne', sans-serif; font-size: 22px; font-weight: 800; color: white; margin-bottom: 8px; }
  .legal-contact-card p { font-size: 15px; color: rgba(255,255,255,0.7); margin-bottom: 20px; }
  .legal-contact-btn { display: inline-block; background: white; color: #1a5c2a; font-weight: 700; font-size: 15px; text-decoration: none; padding: 12px 28px; border-radius: 10px; transition: all 0.2s; }
  .legal-contact-btn:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0,0,0,0.2); }
  .legal-footer { background: #0f1117; padding: 48px 32px 32px; }
  .legal-footer-inner { max-width: 1100px; margin: 0 auto; display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 32px; padding-bottom: 32px; border-bottom: 1px solid rgba(255,255,255,0.08); }
  .legal-footer-brand { font-family: 'Syne', sans-serif; font-size: 20px; font-weight: 800; color: white; display: flex; align-items: center; gap: 10px; margin-bottom: 10px; }
  .legal-footer-tagline { font-size: 13px; color: rgba(255,255,255,0.4); max-width: 220px; }
  .legal-footer-col-title { font-size: 13px; font-weight: 700; color: rgba(255,255,255,0.5); letter-spacing: 1px; text-transform: uppercase; margin-bottom: 16px; }
  .legal-footer-link { display: block; font-size: 14px; color: rgba(255,255,255,0.6); text-decoration: none; margin-bottom: 10px; transition: color 0.2s; }
  .legal-footer-link:hover { color: white; }
  .legal-footer-bottom { max-width: 1100px; margin: 24px auto 0; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; font-size: 13px; color: rgba(255,255,255,0.3); }
  @media (max-width: 768px) { .legal-nav { padding: 0 16px; } .legal-toc-list { grid-template-columns: 1fr; } .legal-footer-inner { flex-direction: column; } .legal-body { padding: 48px 16px 64px; } }
`;

export default function TermsOfService() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const sections = [
    { id: 'services',   num: '1',  title: 'Services' },
    { id: 'account',    num: '2',  title: 'Account & Registration' },
    { id: 'payment',    num: '3',  title: 'Payment & Billing' },
    { id: 'refund',     num: '4',  title: 'Refund Policy' },
    { id: 'use',        num: '5',  title: 'Acceptable Use' },
    { id: 'ip',         num: '6',  title: 'Intellectual Property' },
    { id: 'disclaimer', num: '7',  title: 'Disclaimers' },
    { id: 'liability',  num: '8',  title: 'Limitation of Liability' },
    { id: 'termination',num: '9',  title: 'Termination' },
    { id: 'disputes',   num: '10', title: 'Governing Law & Disputes' },
    { id: 'general',    num: '11', title: 'General' },
  ];

  return (
    <div className="legal-root">
      <style>{styles}</style>

      {/* Navbar */}
      <nav className="legal-nav">
        <Link to="/" className="legal-nav-logo">
          <div className="legal-logo-icon">🍽️</div>
          QR Menu
        </Link>
        <div className="legal-nav-links">
          <Link to="/login" className="legal-btn-signin">Sign In</Link>
          <Link to="/register" className="legal-btn-start" style={{ marginLeft: 8 }}>Get Started</Link>
        </div>
      </nav>

      {/* Hero */}
      <div className="legal-hero">
        <div className="legal-hero-tag">
          <span style={{ width: 8, height: 8, background: '#4ade80', borderRadius: '50%', display: 'inline-block' }} />
          Legal Document
        </div>
        <h1>Terms of Service</h1>
        <p className="legal-hero-sub">Last updated: May 24, 2026 · QR Digi Menu Inc. — A Delaware Corporation</p>
      </div>

      {/* Body */}
      <div className="legal-body">

        <p className="legal-p" style={{ fontSize: 16, color: '#444', marginBottom: 40 }}>
          These Terms of Service ("Terms") are a binding legal agreement between <strong>QR Digi Menu Inc.</strong>,
          a Delaware corporation, and you, the restaurant or food service business registering for or
          using the QR Digi Menu platform ("Customer", "you"). By registering, you agree to these Terms in full.
        </p>

        {/* TOC */}
        <div className="legal-toc">
          <div className="legal-toc-title">📌 Table of Contents</div>
          <ul className="legal-toc-list">
            {sections.map(s => (
              <li key={s.id}><a href={`#${s.id}`}>{s.num}. {s.title}</a></li>
            ))}
          </ul>
        </div>

        {/* Section 1 */}
        <div className="legal-section" id="services">
          <div className="legal-section-title"><span>1</span>Services</div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">1.1 Platform Description</div>
            <p className="legal-p">QR Digi Menu Inc. operates a SaaS platform at getqrdigimenu.com that enables restaurants to:</p>
            <ul className="legal-list">
              <li>Create and manage a digital menu accessible via QR code</li>
              <li>Generate, download, and print QR codes for table placement</li>
              <li>Accept and manage online orders from customers (Pro plan)</li>
              <li>Manage categories, menu items, photos, pricing, and dietary tags</li>
              <li>Access scan analytics and order history</li>
              <li>Manage catering inquiries (Pro plan)</li>
              <li>Customize restaurant profile, hours, and settings</li>
            </ul>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">1.2 Subscription Plans</div>
            <ul className="legal-list">
              <li><strong>Basic Plan ($19.99/month):</strong> Digital menu, QR code generation, analytics</li>
              <li><strong>Pro Plan ($39.99/month):</strong> All Basic features plus online ordering, sound notifications, catering management, priority support</li>
            </ul>
            <p className="legal-p">Annual billing options are available at a discounted rate. Plan features and pricing may change with 30 days' written notice to active subscribers.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">1.3 Service Availability</div>
            <p className="legal-p">We target high availability but do not guarantee uninterrupted service. Scheduled maintenance and emergency fixes may cause temporary downtime. We are not liable for losses resulting from service interruptions.</p>
          </div>
        </div>

        {/* Section 2 */}
        <div className="legal-section" id="account">
          <div className="legal-section-title"><span>2</span>Account & Registration</div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">2.1 Eligibility</div>
            <p className="legal-p">You must be at least 18 years old and legally authorized to enter into contracts on behalf of your business.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">2.2 Accurate Information</div>
            <p className="legal-p">You agree to provide accurate, current, and complete information at registration and to update it if it changes. Providing false information may result in account termination.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">2.3 Account Security</div>
            <p className="legal-p">You are solely responsible for maintaining the confidentiality of your login credentials and for all activities under your account. Notify us immediately at <a href="mailto:hello@getqrdigimenu.com" style={{ color: '#1a5c2a', fontWeight: 600 }}>hello@getqrdigimenu.com</a> if you suspect unauthorized access.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">2.4 One Account Per Location</div>
            <p className="legal-p">Each subscription covers one (1) restaurant location. Multiple locations require separate subscriptions.</p>
          </div>
        </div>

        {/* Section 3 */}
        <div className="legal-section" id="payment">
          <div className="legal-section-title"><span>3</span>Payment & Billing</div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">3.1 Fees</div>
            <p className="legal-p">You agree to pay all applicable subscription and setup fees as displayed at checkout. All fees are in U.S. dollars.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">3.2 Payment Processor</div>
            <p className="legal-p">Payments are processed through Lemon Squeezy (a Stripe company). By providing payment information, you authorize charges to your payment method per your selected plan.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">3.3 Automatic Renewal</div>
            <p className="legal-p">Subscriptions automatically renew each billing period. You may cancel before the renewal date to avoid the next charge. We will send a reminder 3 days before each annual renewal.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">3.4 Failed Payments</div>
            <p className="legal-p">If a payment fails, we will retry. Persistent failure may result in account suspension. Full access restores upon successful payment.</p>
          </div>
        </div>

        {/* Section 4 */}
        <div className="legal-section" id="refund">
          <div className="legal-section-title"><span>4</span>Refund Policy</div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">4.1 Monthly Plans</div>
            <p className="legal-p">Monthly plans may be cancelled at any time. No refund is issued for the current billing period. Access continues until the period ends.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">4.2 Annual Plans</div>
            <p className="legal-p">Annual plans cancelled within 7 days of initial purchase are eligible for a full refund, provided no QR code has been printed and deployed. After 7 days, no refunds are issued.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">4.3 Setup Fee</div>
            <p className="legal-p">One-time setup fees are non-refundable once account access has been granted.</p>
          </div>
          <div className="legal-highlight">
            <p>Full refund policy details are available at <Link to="/refund" style={{ color: '#145022', fontWeight: 700 }}>getqrdigimenu.com/refund</Link></p>
          </div>
        </div>

        {/* Section 5 */}
        <div className="legal-section" id="use">
          <div className="legal-section-title"><span>5</span>Acceptable Use</div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">5.1 Permitted Use</div>
            <p className="legal-p">You may use the platform solely for lawful business operations related to your food service establishment.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">5.2 Prohibited Use</div>
            <p className="legal-p">You agree NOT to:</p>
            <ul className="legal-list">
              <li>Use the platform to facilitate illegal activities</li>
              <li>Upload false, misleading, or deceptive menu content</li>
              <li>Infringe any third-party intellectual property rights</li>
              <li>Attempt to reverse engineer or copy the platform's source code</li>
              <li>Use bots, scrapers, or unauthorized automated tools</li>
              <li>Resell or sublicense platform access to third parties</li>
              <li>Engage in activity that threatens the security or stability of the platform</li>
            </ul>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">5.3 Content Responsibility</div>
            <p className="legal-p">You are solely responsible for all content you upload (menu items, photos, descriptions, pricing). We may remove content that violates these Terms without notice.</p>
          </div>
        </div>

        {/* Section 6 */}
        <div className="legal-section" id="ip">
          <div className="legal-section-title"><span>6</span>Intellectual Property</div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">6.1 Company Ownership</div>
            <p className="legal-p">The platform and all associated software, design, trademarks, and content are the exclusive property of QR Digi Menu Inc. You receive a limited, non-exclusive, non-transferable, revocable license to use the platform during your active subscription.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">6.2 Your Content</div>
            <p className="legal-p">You retain ownership of all content you upload. You grant QR Digi Menu Inc. a non-exclusive, royalty-free license to host, display, and process your content solely as needed to provide the service.</p>
          </div>
        </div>

        {/* Section 7 */}
        <div className="legal-section" id="disclaimer">
          <div className="legal-section-title"><span>7</span>Disclaimers</div>
          <div className="legal-caps">
            THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT ANY WARRANTIES, EXPRESS OR IMPLIED,
            INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
            WE DO NOT WARRANT THAT THE PLATFORM WILL BE ERROR-FREE OR UNINTERRUPTED.
          </div>
          <p className="legal-p">We are a technology platform only. We are not responsible for the accuracy of menu items, prices, food quality, order fulfillment, or any disputes between you and your customers.</p>
        </div>

        {/* Section 8 */}
        <div className="legal-section" id="liability">
          <div className="legal-section-title"><span>8</span>Limitation of Liability</div>
          <div className="legal-caps">
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, QR DIGI MENU INC. SHALL NOT BE LIABLE FOR ANY INDIRECT,
            INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE PLATFORM,
            INCLUDING LOST PROFITS OR DATA, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          </div>
          <div className="legal-caps" style={{ marginTop: 12 }}>
            OUR TOTAL AGGREGATE LIABILITY FOR ANY CLAIM ARISING UNDER THESE TERMS SHALL NOT EXCEED THE TOTAL
            FEES PAID BY YOU IN THE THREE (3) MONTHS PRECEDING THE CLAIM.
          </div>
        </div>

        {/* Section 9 */}
        <div className="legal-section" id="termination">
          <div className="legal-section-title"><span>9</span>Termination</div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">9.1 By Customer</div>
            <p className="legal-p">You may cancel your subscription at any time via your account settings or by emailing <a href="mailto:hello@getqrdigimenu.com" style={{ color: '#1a5c2a', fontWeight: 600 }}>hello@getqrdigimenu.com</a>. Cancellation takes effect at the end of the current billing period.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">9.2 By Company</div>
            <p className="legal-p">We may suspend or terminate your account immediately without notice for violation of these Terms, fraudulent activity, or conduct that poses a threat to the platform.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">9.3 Effect of Termination</div>
            <p className="legal-p">Upon termination, your access ceases. We retain your data for 30 days, after which it may be permanently deleted. You may request a data export before termination.</p>
          </div>
        </div>

        {/* Section 10 */}
        <div className="legal-section" id="disputes">
          <div className="legal-section-title"><span>10</span>Governing Law & Disputes</div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">10.1 Governing Law</div>
            <p className="legal-p">These Terms are governed by the laws of the State of Delaware, without regard to conflict of law principles.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">10.2 Informal Resolution</div>
            <p className="legal-p">Before initiating any legal action, you agree to contact us at <a href="mailto:hello@getqrdigimenu.com" style={{ color: '#1a5c2a', fontWeight: 600 }}>hello@getqrdigimenu.com</a> and attempt resolution in good faith within 30 days.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">10.3 Arbitration & Class Action Waiver</div>
            <p className="legal-p">Unresolved disputes shall be submitted to binding arbitration under AAA rules, seated in Delaware. All disputes shall be resolved individually — you waive any right to participate in a class action lawsuit or class-wide arbitration against QR Digi Menu Inc.</p>
          </div>
        </div>

        {/* Section 11 */}
        <div className="legal-section" id="general">
          <div className="legal-section-title"><span>11</span>General</div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">11.1 Changes to Terms</div>
            <p className="legal-p">We may update these Terms with 14 days' email notice for material changes. Continued use after the effective date constitutes acceptance.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">11.2 Entire Agreement</div>
            <p className="legal-p">These Terms, the <Link to="/privacy" style={{ color: '#1a5c2a', fontWeight: 600 }}>Privacy Policy</Link>, and the <Link to="/refund" style={{ color: '#1a5c2a', fontWeight: 600 }}>Refund Policy</Link> constitute the entire agreement between you and QR Digi Menu Inc.</p>
          </div>
          <div className="legal-subsection">
            <div className="legal-subsection-title">11.3 Contact</div>
            <ul className="legal-list">
              <li><strong>Company:</strong> QR Digi Menu Inc. (A Delaware Corporation)</li>
              <li><strong>Address:</strong> 8 The Green #23752, Dover, DE 19901</li>
              <li><strong>Email:</strong> <a href="mailto:hello@getqrdigimenu.com" style={{ color: '#1a5c2a', fontWeight: 600 }}>hello@getqrdigimenu.com</a></li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="legal-contact-card">
          <h3>Questions about these Terms?</h3>
          <p>We're happy to clarify anything before you sign up.</p>
          <a href="mailto:hello@getqrdigimenu.com" className="legal-contact-btn">📧 Contact Us</a>
        </div>
      </div>

      {/* Footer */}
      <footer className="legal-footer">
        <div className="legal-footer-inner">
          <div>
            <div className="legal-footer-brand">
              <div style={{ width: 32, height: 32, background: '#1a5c2a', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>🍽️</div>
              QR Menu
            </div>
            <div className="legal-footer-tagline">The complete digital menu platform for modern restaurants.</div>
          </div>
          <div>
            <div className="legal-footer-col-title">Product</div>
            <Link to="/#features" className="legal-footer-link">Features</Link>
            <Link to="/#pricing" className="legal-footer-link">Pricing</Link>
            <Link to="/#how-it-works" className="legal-footer-link">How it works</Link>
          </div>
          <div>
            <div className="legal-footer-col-title">Account</div>
            <Link to="/register" className="legal-footer-link">Get Started</Link>
            <Link to="/login" className="legal-footer-link">Sign In</Link>
          </div>
          <div>
            <div className="legal-footer-col-title">Legal</div>
            <Link to="/privacy" className="legal-footer-link">Privacy Policy</Link>
            <Link to="/terms" className="legal-footer-link" style={{ color: 'rgba(255,255,255,0.9)' }}>Terms of Service</Link>
            <Link to="/refund" className="legal-footer-link">Refund Policy</Link>
          </div>
        </div>
        <div className="legal-footer-bottom">
          <span>© {new Date().getFullYear()} QR Digi Menu Inc. All rights reserved.</span>
          <span>Built for restaurants worldwide 🌍</span>
        </div>
      </footer>
    </div>
  );
}